<template>
  <button :class="classes.button" type="button" @click="scrollTo(item)">
    {{ item.title }}
  </button>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapState } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mediaQuery: undefined
    }
  },
  computed: {
    ...mapState(['currentSection']),
    classes() {
      return {
        button: [
          this.$style.button,
          this.isActive ? this.$style['is-active'] : ''
        ]
      }
    },
    isActive() {
      return this.currentSection === this.index
    }
  },
  methods: {
    scrollTo(el) {
      VueScrollTo.scrollTo('#' + el.name, { offset: this.scrollOffset })
    },
    scrollOffset() {
      // Don’t convert to computed property as offset needs to be re-calculated on breakpoints below 48em
      const offset = this.mediaQuery.matches
        ? 0
        : this.$parent.$refs.nav.clientHeight * -1 + 2 // TODO: +2, but why?
      return offset
    }
  },
  mounted() {
    this.mediaQuery = window.matchMedia('(min-width: 48em)')
  }
}
</script>

<style lang="scss" module>
.button {
  // display: block;
  break-inside: avoid-column; // prevent breaking into next line when content is to long
  display: inline-block; // Fix for FF.
  width: 100%;
  text-align: left;
  transition: color var(--short) ease;

  &.is-active {
    color: var(--white);
  }

  @media #{$mqHover} {
    transition: color var(--short) ease;

    &:hover {
      color: var(--white);
    }
  }
}
</style>
